import { api } from './client';

export interface ProgressItem {
  userId: string;
  mediaId: string;
  kind: string | null;
  positionSec: number;
  durationSec: number | null;
  completed: boolean;
  lastWatchedAt: { _seconds: number; _nanoseconds: number } | null;
}

export async function getContinueWatching() {
  return api.get<{ items: ProgressItem[] }>('/api/progress');
}

export async function getProgress(mediaId: string) {
  return api.get<ProgressItem | { mediaId: string; positionSec: number; completed: boolean }>(
    `/api/progress/${mediaId}`,
  );
}

export async function putProgress(mediaId: string, body: {
  positionSec: number;
  durationSec?: number | null;
  completed?: boolean;
  kind?: string;
}) {
  return api.put<{ ok: true }>(`/api/progress/${mediaId}`, body);
}
